import { render, staticRenderFns } from "./ProductsOverview.vue?vue&type=template&id=ae5f4360&scoped=true&lang=pug"
import script from "./ProductsOverview.vue?vue&type=script&lang=js"
export * from "./ProductsOverview.vue?vue&type=script&lang=js"
import style0 from "./ProductsOverview.vue?vue&type=style&index=0&id=ae5f4360&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae5f4360",
  null
  
)

export default component.exports